import { Component, Inject, model } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { DialogData } from '../../../my-account/customer-service/customer-service.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CnesFinderService, CNES } from './cnes-finder.service';

@Component({
    selector: 'app-cnes-finder',
    standalone: true,
    imports: [MaterialModule, FormsModule],
    templateUrl: './dialog-cnes-finder.component.html',
    styleUrl: './dialog-cnes-finder.component.scss'
})
export class DialogCNESFinderComponent {
  cnes = model(this.data.newCustomerService);
  cnsFound: CNES | null | undefined;
  subject!: string;
  message!: string;

  constructor(
    public dialogRef: MatDialogRef<DialogCNESFinderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private cnesFinderService: CnesFinderService
  ) {}

  findCnes(code: string) {
    this.cnsFound = this.cnesFinderService.findCNS(code);
    // this.cnesFinderService.findCNS(code).subscribe((cnsResponse) => {
    //   this.cnsFound = cnsResponse;
    // });

    // this.dialogRef.close();
  }
}
